(() => {
  const roots = document.querySelectorAll("[data-promo-banner]");
  if (!roots.length) return;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  roots.forEach((root) => {
    if (root.dataset.promoReady === "true") return;
    root.dataset.promoReady = "true";

    const track = root.querySelector("[data-promo-track]");
    const items = Array.from(root.querySelectorAll("[data-promo-item]"));
    const prev = root.querySelector("[data-promo-prev]");
    const next = root.querySelector("[data-promo-next]");
    if (!track || items.length < 2) return;

    let index = Math.max(
      0,
      items.findIndex((item) => item.classList.contains("is-active"))
    );
    const speed = Number(root.dataset.speed) || 4000;
    const autoplayOn = root.dataset.autoplay !== "false" && !reduceMotion;
    let timer = null;
    let dragStartX = 0;
    let dragDelta = 0;
    let dragging = false;

    const setActive = () => {
      items.forEach((item, i) => {
        const on = i === index;
        item.classList.toggle("is-active", on);
        if (on) item.removeAttribute("aria-hidden");
        else item.setAttribute("aria-hidden", "true");
      });
    };

    const render = (offsetPx) => {
      const width = root.querySelector(".promo-banner__viewport")?.clientWidth || root.clientWidth;
      const shift = -index * 100 + (width ? (offsetPx / width) * 100 : 0);
      track.style.transform = "translate3d(" + shift + "%, 0, 0)";
    };

    const go = (nextIndex) => {
      index = (nextIndex + items.length) % items.length;
      setActive();
      render(0);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (!autoplayOn) return;
      stop();
      timer = window.setInterval(() => go(index + 1), speed);
    };

    const restart = () => {
      stop();
      start();
    };

    prev?.addEventListener("click", () => {
      go(index - 1);
      restart();
    });
    next?.addEventListener("click", () => {
      go(index + 1);
      restart();
    });

    const onPointerDown = (event) => {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      dragging = true;
      dragStartX = event.clientX;
      dragDelta = 0;
      track.classList.add("is-dragging");
      stop();
      track.setPointerCapture?.(event.pointerId);
    };

    const onPointerMove = (event) => {
      if (!dragging) return;
      dragDelta = event.clientX - dragStartX;
      render(dragDelta);
    };

    const onPointerUp = () => {
      if (!dragging) return;
      dragging = false;
      track.classList.remove("is-dragging");
      const width = root.querySelector(".promo-banner__viewport")?.clientWidth || 1;
      if (Math.abs(dragDelta) > width * 0.18) {
        go(index + (dragDelta < 0 ? 1 : -1));
      } else {
        render(0);
      }
      restart();
    };

    track.addEventListener("pointerdown", onPointerDown);
    track.addEventListener("pointermove", onPointerMove);
    track.addEventListener("pointerup", onPointerUp);
    track.addEventListener("pointercancel", onPointerUp);

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", () => {
      if (!dragging) start();
    });
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stop();
      else start();
    });
    window.addEventListener("resize", () => render(0), { passive: true });

    setActive();
    render(0);
    start();
  });
})();
